import {createAsyncThunk} from "@reduxjs/toolkit"
import {AppThunkProps} from "store"
import {api} from "utils/http"
import {BasicMenu} from "types/BasicMenu"

interface ArgsProps {
    id: number
    data: {
        title: string
        text: string
    }
}

type ReturnedType = {
    status: "success"
    menu: BasicMenu
}

/**
 * Создание меню
 */
export const updateBasicMenu = createAsyncThunk<ReturnedType, ArgsProps, AppThunkProps>(
    "basic-menu/update",
    async ({id, data}, {signal}) => {
        return api.patch<ReturnedType>(`/user/basic-menu/${id}`, data, {signal})
    }
)
